/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Male_Maroon_Slug_DelightInputs */

const fr_male_maroon_slug_delight = /** @type {(inputs: Male_Maroon_Slug_DelightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercices`)
};

/**

* @param {Male_Maroon_Slug_DelightInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const male_maroon_slug_delight = /** @type {((inputs?: Male_Maroon_Slug_DelightInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Male_Maroon_Slug_DelightInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_male_maroon_slug_delight(inputs)
});